<template>
  <!--
      作者：zhuchangtao
      时间：2020-12-12
      描述：插件中心-抽奖活动
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="奖品管理" name="prize"></el-tab-pane>
      <el-tab-pane label="抽奖码管理" name="lottery"></el-tab-pane>
      <el-tab-pane label="参与抽奖用户" name="user"></el-tab-pane>
      <el-tab-pane label="抽奖记录" name="draw"></el-tab-pane>
      <el-tab-pane label="中奖记录" name="win"></el-tab-pane>
      <el-tab-pane label="领奖记录" name="accept"></el-tab-pane>
      <el-tab-pane label="抽奖设置" name="setting"></el-tab-pane>
    </el-tabs>
    <!--奖品管理-->
    <Prize v-if="activeName == 'prize'"></Prize>
    <!--抽奖码管理-->
    <Lottery v-if="activeName == 'lottery'"></Lottery>
    <!--参与抽奖用户-->
    <User v-if="activeName == 'user'"></User>
    <!--抽奖记录-->
    <Draw v-if="activeName == 'draw'"></Draw>
    <!--中奖记录-->
    <Win v-if="activeName == 'win'"></Win>
    <!--领奖记录-->
    <Accept v-if="activeName == 'accept'"></Accept>
    <!--砍价设置-->
    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import Lottery from './lottery/index.vue';
import Prize from './prize/index.vue';
import Draw from './draw/index.vue';
import Win from './win/index.vue';
import Accept from './accept/index.vue';
import Setting from './setting/index.vue';
import User from './user/index.vue';
export default {
  components: {
    Lottery,
    Prize,
    Draw,
    Win,
    Accept,
    Setting,
	User
  },
  data() {
    return {

      /*当前选中*/
      activeName: 'prize'
    };
  },
  created() {
    /*获取列表*/


    // localStorage.setItem('activeName',this.activeName)

    let active_name = localStorage.getItem('activeName')


    if(active_name){
      this.activeName = active_name
      localStorage.clear()
    }
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/index.vue